import { useEffect } from 'react';
import { listen } from './listen';
import { listenOutside } from './listenOutside';
/**
 * Creates a hook for listening to the specified types of events.
 * @param type Types of events to listen to.
 * @param options EventListener options.
 * @example
 * const useClickOutside = createEventHook('click', { outside: true });
 * const useInteract = createEventHook(['focus', 'mouseenter', 'touchstart']);
 */
export function createEventHook(type, { outside = false, ...options } = {}) {
    const listenFn = outside ? listenOutside : listen;
    /**
     * Listens to the specified events and calls `onEvent` when one fires.
     * @param onEvent Function to call when one of the events fires.
     * @param target Nodes or RefObjects of nodes to listen on.
     */
    return (onEvent, targets) => useEffect(() => listenFn(type, targets, onEvent, options), targets);
}
//# sourceMappingURL=createEventHook.js.map